import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  header: {
    backgroundColor: theme.colors["deep-blue"][0],
    paddingTop: "1px",
    borderBottom: 0,
    marginBottom: 0,
  },
  menu: {
    backgroundColor: theme.colors["deep-blue"][0],
  },
  line: {
    background: theme.colors.gold[0],
    height: "4px",
  },
  links: {
    [theme.fn.smallerThan("sm")]: {
      display: "none",
    },
  },
  button: {
    borderRadius: "0",
    height: "39px",
    background: "transparent",
    borderRightColor: "#FFF",
    fontSize: "15px",
    fontWeight: "300",
    lineHeigth: "18px",
    "&:last-child": {
      borderRightColor: "transparent",
    },
    "&:hover": {
      backgroundColor: theme.colors.gray[1],
      color: theme.colors["deep-blue"][0],
      borderBottom: "4px",
      borderStyle: "solid",
      borderBottomColor: theme.colors.gold[0],
    },
  },
  textMenu: {
    color: theme.colors["deep-blue"][0],
    fontSize: "15px",
    fontWeight: "300",
    paddingTop: "13px",
    paddingBottom: "13px",
    paddingLeft: "48px",
    paddingRight: "48px",
    lineHeigth: "18px",
    "&:hover": {
      background: theme.colors.gray[1],
      borderRadius: "0",
    },
  },
}));

export default useStyles;
